export const getEntityTypeColor = (type: string) => {
  switch (type) {
    case 'individual':
      return 'bg-blue-100 text-blue-800';
    case 'company':
      return 'bg-green-100 text-green-800';
    case 'fund':
      return 'bg-purple-100 text-purple-800';
    case 'trust':
      return 'bg-orange-100 text-orange-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

export const formatIban = (iban: string) => {
  // Remove any existing spaces and format with spaces every 4 characters
  const cleanIban = iban.replace(/\s/g, '');
  return cleanIban.replace(/(.{4})/g, '$1 ').trim();
};

export const formatContactRole = (role: string) => {
  // Map role codes to human-readable labels
  const roleMap: Record<string, string> = {
    money_manager: 'Money Manager',
    authorized_signatory: 'Authorized Signatory',
    beneficial_owner: 'Beneficial Owner',
    contact_person: 'Contact Person',
    legal_counsel: 'Legal Counsel',
  };

  return (
    roleMap[role] ||
    role.replaceAll('_', ' ').replace(/\b\w/g, (l) => l.toUpperCase())
  );
};
